import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationWatcherEntity } from '../../../domain/entities/investigation-watcher.entity';

export interface GetInvestigationWatchersQuery { investigationId: string; }
export interface GetInvestigationWatchersResult { watchers: InvestigationWatcherEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationWatchersUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationWatchersQuery): Observable<GetInvestigationWatchersResult> {
    this._state.setLoadingWatchers(true);
    return this._repository.getWatchers(query.investigationId).pipe(
      tap((watchers) => { this._state.setWatchers(watchers); this._state.setLoadingWatchers(false); }),
      map((watchers) => ({ watchers })),
      catchError((error) => { this._state.setLoadingWatchers(false); return throwError(() => error); }),
    );
  }
}
